import { AppStorage } from "@bbwt/utils/app-storage";
import { Notification } from "./notification";

export class NotificationOfflineStorage {
    private static readonly cacheKey = "api/notifications";

    static save(notification: Notification): Notification {
        return AppStorage.setOfflineEntity<Notification>(this.cacheKey, notification);
    }

    static remove(id: string): Notification {
        return AppStorage.extractOfflineEntity<Notification>(id, this.cacheKey);
    }

    static update(notification: Notification): Notification {
        return AppStorage.replaceOfflineEntity<Notification>(notification, this.cacheKey);
    }

    static getAll(): Notification[] {
        return AppStorage.getOfflineEntities<Notification>(this.cacheKey);
    }
}
